"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClearFormatButton = exports.DbgButton = exports.BlockPropButton = exports.FontColorButton = void 0;
var react_1 = __importStar(require("react"));
var slate_react_1 = require("slate-react");
var slate_1 = require("slate");
var styled_components_1 = __importDefault(require("styled-components"));
var CUSTOM_PROPERTIES = ['url'];
var setFontColorValue = function setFontColorValue(editor, value) {
  slate_1.Transforms.select(editor, editor._onBlurSelection);
  if (value) {
    slate_1.Editor.addMark(editor, 'color', value.toString());
  }
};
var getFontColorValue = function getFontColorValue(editor) {
  var defaultColor = '#000000';
  var marks = slate_1.Editor.marks(editor);
  if (marks && marks.color) {
    return marks.color;
  }
  return defaultColor;
};
var isMarkActive = function isMarkActive(editor, format) {
  var marks = slate_1.Editor.marks(editor);
  return marks ? marks[format] === true : false;
};
var IconWrapper = function IconWrapper(props) {
  return react_1.default.createElement("div", __assign({
    style: {
      margin: 3,
      width: 30,
      height: 30,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontWeight: props.active ? 'bold' : 'normal',
      backgroundColor: props.active ? '#eee' : 'white',
      cursor: 'pointer'
    }
  }, props), props.children);
};
function FontColorButton(props) {
  var editor = slate_react_1.useSlate();
  var _a = react_1.useState(),
    pickedColor = _a[0],
    setPickedColor = _a[1];
  return react_1.default.createElement(IconWrapper, {
    title: "\u6587\u5B57\u984F\u8272",
    active: isMarkActive(editor, 'color')
  }, react_1.default.createElement("label", {
    htmlFor: "richtext-font-color",
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, react_1.default.createElement(FormatColorTextIcon, {
    size: 18,
    color: getFontColorValue(editor)
  })), react_1.default.createElement("input", {
    style: {
      opacity: 0,
      width: 0,
      height: 0,
      position: 'absolute',
      top: 0,
      right: 0
    },
    type: "color",
    id: "richtext-font-color",
    name: "richtext-font-color",
    value: getFontColorValue(editor),
    onBlur: function onBlur() {
      setFontColorValue(editor, pickedColor);
    },
    onChange: function onChange(e) {
      setPickedColor(e.target.value);
    }
  }));
}
exports.FontColorButton = FontColorButton;
var FormatColorTextIcon = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", "px;\n  height: ", "px;\n  background-color: ", ";\n  border-radius: 50%;\n"], ["\n  width: ", "px;\n  height: ", "px;\n  background-color: ", ";\n  border-radius: 50%;\n"])), function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.color;
});
var isBlockPropActive = function isBlockPropActive(editor, format, value) {
  if (value === void 0) {
    value = true;
  }
  var it = slate_1.Editor.nodes(editor, {
    match: function match(n) {
      return n[format] === value;
    }
  });
  return !!it.next().value;
};
var BlockPropButton = function BlockPropButton(_a) {
  var title = _a.title,
    format = _a.format,
    icon = _a.icon,
    _b = _a.value,
    value = _b === void 0 ? true : _b;
  var editor = slate_react_1.useSlate();
  var active = isBlockPropActive(editor, format, value);
  var toggle = react_1.useCallback(function (editor, format, value) {
    var _a;
    slate_1.Transforms.unsetNodes(editor, format, {
      match: function match(n) {
        return n[format] === value;
      }
    });
    if (!active) {
      slate_1.Transforms.setNodes(editor, (_a = {}, _a[format] = value, _a));
    }
  }, [active]);
  return react_1.default.createElement(IconWrapper, {
    title: title,
    active: active,
    onMouseDown: function onMouseDown(event) {
      event.preventDefault();
      toggle(editor, format, value);
    }
  }, icon);
};
exports.BlockPropButton = BlockPropButton;
function DbgButton(props) {
  var editor = slate_react_1.useSlate();
  return react_1.default.createElement(IconWrapper, {
    onClick: function onClick() {
      console.log(editor);
      console.log(JSON.stringify(editor.children, null, 2));
    }
  }, props.icon || 'DBG');
}
exports.DbgButton = DbgButton;
function ClearFormatButton(props) {
  var editor = slate_react_1.useSlate();
  var clearBlock = react_1.useCallback(function (editor) {
    //not working
    slate_1.Transforms.unsetNodes(editor, [], {
      mode: 'all',
      match: function match(n) {
        for (var _i = 0, CUSTOM_PROPERTIES_1 = CUSTOM_PROPERTIES; _i < CUSTOM_PROPERTIES_1.length; _i++) {
          var x = CUSTOM_PROPERTIES_1[_i];
          if (n.hasOwnProperty(x)) {
            return false;
          }
        }
        return true;
      }
      // CUSTOM_PROPERTIES.reduce((sum, x) => sum && !n.hasOwnProperty(x), true),
    });
  }, []);
  return react_1.default.createElement(IconWrapper, {
    onMouseDown: function onMouseDown(event) {
      event.preventDefault();
      clearBlock(editor);
      // clearMarks(editor);
      // clearAlignmentBlocks(editor);
    }
  }, props.icon);
}
exports.ClearFormatButton = ClearFormatButton;
var templateObject_1;